module.exports = __webpack_public_path__ + "img/b_s_2.a6f0dcfc.png";